import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrandRoutingModule } from './brand-routing.module';
import { BrandComponent } from './brand.component';
import { ListComponent } from './list/list.component';
import { DetailComponent } from './detail/detail.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { FooterModule } from '../global/footer/footer.module';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { PaginatorModule } from 'primeng/paginator';

@NgModule({
  declarations: [
    BrandComponent,
    ListComponent,
    DetailComponent
  ],
  imports: [
    CommonModule,
    BrandRoutingModule,
    SharedModule,
    RouterModule,
    FooterModule,
    DialogModule,
    SidebarModule,
    PaginatorModule
  ]
})
export class BrandModule { }
